import { useEffect } from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Layout } from "@components/Layout/index";
import { getModalSettings, getGlobalConfig } from "@lib/api/calls";
import { SearchView } from "@components/Search";
import { trackEvent } from "@lib/track-event";

export default function Search({ preview, title = "Search", seo, subscribed, modal, config }) {
  useEffect(() => {
    trackEvent("view_page", {
      pageTitle: title,
      pageCategory: "Search Page",
      pageLocation: window.location.href,
      pagePath: window.location.pathname,
    });
  }, []);
  return (
    <Layout
      config={config}
      title={title}
      seo={seo}
      subscribed={subscribed}
      isPreview={preview}
      modal={modal}
      pageFound={true}
    >
      <SearchView />
    </Layout>
  );
}

export async function getStaticProps({ preview = false, locale }) {
  const config = await getGlobalConfig(locale, preview);
  const modal = await getModalSettings(locale, preview);

  const seo = {
    seoTitle: null,
    seoDescription: null,
    openGraphImage: null,
    twitterCard: "summary_large_image",
  };

  return {
    props: {
      preview,
      title: "Kotn · Search",
      seo,
      modal,
      config,
      ...(await serverSideTranslations(locale, [
        "common",
        "navbar",
        "footer",
        "productcard",
        "cart",
        "filter",
        "recommendations",
      ])),
    },
    revalidate: 1800,
  };
}
